export default "__VITE_ASSET__foO5ZeVB__"